var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42166 0.96582C1.27046 0.96582 1.12545 1.02588 1.01854 1.1328C0.911626 1.23971 0.851563 1.38472 0.851562 1.53592V16.3584C0.851563 16.5096 0.911626 16.6546 1.01854 16.7615C1.12545 16.8684 1.27046 16.9285 1.42166 16.9285C1.57286 16.9285 1.71786 16.8684 1.82478 16.7615C1.93169 16.6546 1.99175 16.5096 1.99175 16.3584V10.0874H11.6834C11.7961 10.0873 11.9062 10.0538 11.9999 9.99112C12.0935 9.92847 12.1665 9.83947 12.2096 9.73536C12.2527 9.63125 12.264 9.5167 12.2421 9.40618C12.2201 9.29566 12.1659 9.19412 12.0863 9.11439L8.49845 5.52659L12.0863 1.93878C12.1659 1.85906 12.2201 1.75752 12.2421 1.647C12.264 1.53648 12.2527 1.42193 12.2096 1.31782C12.1665 1.21371 12.0935 1.12471 11.9999 1.06206C11.9062 0.999409 11.7961 0.965919 11.6834 0.96582H1.42166ZM1.99175 8.94717V2.10601H10.3076L7.28985 5.12372C7.18309 5.23061 7.12312 5.37551 7.12312 5.52659C7.12312 5.67767 7.18309 5.82256 7.28985 5.92946L10.3076 8.94717H1.99175Z",
    fill: "#F58634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.ec09f50928c1a221405c6a06837f2ea4.svg";
export { ForwardRef as ReactComponent };